import declare from "dojo/_base/declare";
import StringRen from "csi/heading/String";
import ActualMixin from "./ActualMixin";

const SampleActualComment = declare([StringRen, ActualMixin], {

	reserveContext(/*Context*/ctx, /*Heading*/h) {
		// summary: change context to correct Sample based on keyValue - path always takes us to first Sample for selected size
		const scd = ctx.getNode();
		ctx.keyValue = this._getDimensionActualsKey(ctx, scd);
		ctx.keyValue2 = this._getDimensionActualsKeyPre47(ctx, scd);
		ctx.keySuffix = this._getDimensionActualsKeySuffix(ctx, scd);
		ctx.pushParams().setNodeURL(ctx.view._urlSampleDims);
		ctx.setReadOnly(false);
		this.inherited(arguments);
	},
});

export = SampleActualComment;